import { render, staticRenderFns } from "./AddSimcard.vue?vue&type=template&id=44cbaefa&scoped=true"
import script from "./AddSimcard.vue?vue&type=script&lang=js"
export * from "./AddSimcard.vue?vue&type=script&lang=js"
import style0 from "./AddSimcard.vue?vue&type=style&index=0&id=44cbaefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbaefa",
  null
  
)

export default component.exports